/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "सुंदर HTML संपादक एक्सेस करें"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "पहुंच जांचकर्ता"
  },
  "action_to_take_b626a99a": {
    "message": "कार्रवाई:"
  },
  "add_8523c19b": {
    "message": "जोड़ें"
  },
  "add_a_caption_2a915239": {
    "message": "कैप्शन जोड़ें"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "छवि के लिए वैकल्पिक पाठ जोड़ें"
  },
  "add_another_f4e50d57": {
    "message": "कोई अन्य जोड़ें"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "CC/उपशीर्षक जोड़ें"
  },
  "add_image_60b2de07": {
    "message": "छवि जोड़ें"
  },
  "add_one_9e34a6f8": {
    "message": "एक जोड़ें!"
  },
  "additional_considerations_f3801683": {
    "message": "अतिरिक्त विचार"
  },
  "address_applied_64269b0b": {
    "message": "पता लागू किया गया"
  },
  "address_removed_fcb496e0": {
    "message": "पता निकाला गया"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "समान URL वाले निकटवर्ती लिंक एक ही लिंक होने चाहिए।"
  },
  "aleph_f4ffd155": {
    "message": "एलेफ़"
  },
  "align_11050992": {
    "message": "संरेखण करें"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "संरेखण और सूचियां"
  },
  "all_4321c3a1": {
    "message": "सभी"
  },
  "all_apps_a50dea49": {
    "message": "सभी ऐप्स"
  },
  "allow_media_download_16dcf2bd": {
    "message": "मीडिया डाउनलोड की अनुमति दें"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "ट्रांसक्रिप्ट डाउनलोड की अनुमति दें"
  },
  "alpha_15d59033": {
    "message": "अल्फ़ा"
  },
  "alphabetical_55b5b4e0": {
    "message": "वर्णानुक्रमिक"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "वैकल्पिक एट्रिब्यूट पाठ में 120 से अधिक कैरेक्टर नहीं होने चाहिए।"
  },
  "alt_text_611fb322": {
    "message": "वैकल्पिक पाठ"
  },
  "amalg_coproduct_c589fb12": {
    "message": "मिश्रण (उपोत्पाद)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "फ़ाइल पढ़ने के दौरान त्रुटि उत्पन्न हुई"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "नेटवर्क अनुरोध करते समय त्रुटि उत्पन्न हुई"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "आपका मीडिया अपलोड करने के दौरान त्रुटि उत्पन्न हुई।"
  },
  "and_7fcc2911": {
    "message": "और"
  },
  "angle_c5b4ec50": {
    "message": "कोण"
  },
  "announcement_fb4cb645": {
    "message": "घोषणा"
  },
  "announcement_list_da155734": {
    "message": "घोषणा सूची"
  },
  "announcements_a4b8ed4a": {
    "message": "घोषणाएं"
  },
  "apply_781a2546": {
    "message": "लागू करें"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "पाठ्यक्रम में इस Icon Maker आइकन के सभी उदाहरणों में परिवर्तन लागू करें"
  },
  "approaches_the_limit_893aeec9": {
    "message": "सीमा तक पहुंचने वाला है"
  },
  "approximately_e7965800": {
    "message": "लगभग"
  },
  "apps_54d24a47": {
    "message": "ऐप"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "क्या आप सच में रद्द करना चाहते हैं? हो सकता है आपके द्वारा किए गए परिवर्तन सहेजे नहीं जा सकें।"
  },
  "arrows_464a3e54": {
    "message": "तीर"
  },
  "art_icon_8e1daad": {
    "message": "आर्ट आइकन"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "पक्षानुपात संरक्षित किया जाएगा"
  },
  "assignment_976578a8": {
    "message": "असाइनमेंट"
  },
  "assignments_1e02582c": {
    "message": "असाइनमेंट"
  },
  "asterisk_82255584": {
    "message": "तारांकन चिह्न"
  },
  "attributes_963ba262": {
    "message": "एट्रिब्यूट"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "ऑडियो और वीडियो रिकॉर्डिंग समर्थित नहीं; कृपया किसी भिन्न ब्राउज़र का उपयोग करें।"
  },
  "audio_options_feb58e2c": {
    "message": "ऑडियो विकल्प "
  },
  "audio_options_tray_33a90711": {
    "message": "ऑडियो विकल्प ट्रे"
  },
  "audio_player_for_title_20cc70d": {
    "message": "{ title } के लिए ऑडियो प्लेयर"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "स्वत: सहेजी गई सामग्री मौजूद है। क्या आप इसके बजाय स्वतः सहेजी गई सामग्री को लोड करना चाहेंगे?"
  },
  "available_folders_694d0436": {
    "message": "उपलब्ध फ़ोल्डर"
  },
  "background_1bc88842": {
    "message": "पृष्ठभूमि"
  },
  "backslash_b2d5442d": {
    "message": "बैकस्लैश"
  },
  "bar_ec63ed6": {
    "message": "बार"
  },
  "basic_554cdc0a": {
    "message": "मूलभूत"
  },
  "because_501841b": {
    "message": "क्योंकि"
  },
  "below_81d4dceb": {
    "message": "नीचे"
  },
  "beta_cb5f307e": {
    "message": "बीटा"
  },
  "big_circle_16b2e604": {
    "message": "बड़ा वृत्त"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "द्विपद गुणांक"
  },
  "black_4cb01371": {
    "message": "काला"
  },
  "blue_daf8fea9": {
    "message": "नीला"
  },
  "bold_applied_42d547b7": {
    "message": "बोल्ड लागू किया गया"
  },
  "bold_removed_da474a5c": {
    "message": "बोल्ड निकाला गया"
  },
  "border_5b08b06d": {
    "message": "बॉर्डर"
  },
  "bottom_15a2a9be": {
    "message": "तल"
  },
  "bottom_third_5f5fec1d": {
    "message": "नीचे से तीसरा"
  },
  "bowtie_5f9629e4": {
    "message": "बोटाई"
  },
  "brick_f2656265": {
    "message": "ईंट"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "रद्द करें"
  },
  "cap_product_3a5265a6": {
    "message": "कैप उत्पाद"
  },
  "caption_manager_aae0906f": {
    "message": "कैप्शन मैनेजर"
  },
  "center_align_e68d9997": {
    "message": "केंद्र संरेखित"
  },
  "centered_dot_64d5e378": {
    "message": "केंद्रित बिंदु"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "केंद्रित क्षैतिज बिंदु"
  },
  "change_alt_text_92654906": {
    "message": "वैकल्पिक पाठ बदलें"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "हेडिंग टैग को पैराग्राफ़ में बदलें"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "केवल इस हेडिंग का स्तर बदलें"
  },
  "change_text_color_1aecb912": {
    "message": "पाठ रंग बदलें"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "इस पेज को सहेजने के बाद बदलाव लागू हो जाएंगे।"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "हो सकता है आपके द्वारा किए गए परिवर्तन सहेजे नहीं जा सकें।"
  },
  "characters_9d897d1c": {
    "message": "कैरेक्टर"
  },
  "characters_no_spaces_485e5367": {
    "message": "कैरेक्टर (कोई स्पेस नहीं)"
  },
  "check_accessibility_3c78211c": {
    "message": "पहुंच की जांच करें"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "पहुंच संबंधी समस्याओं की जांच करें"
  },
  "chi_54a32644": {
    "message": "ची"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "कैप्शन फ़ाइल चुनें"
  },
  "choose_usage_rights_33683854": {
    "message": "उपयोग अधिकार चुनें..."
  },
  "circle_484abe63": {
    "message": "वृत्त"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "अक्रमित सूची पर वृत्त बनाएं"
  },
  "clear_2084585f": {
    "message": "साफ़ करें"
  },
  "clear_image_3213fe62": {
    "message": "छवि साफ़ करें"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "HTML संपादक के लिए क्लिक या Shift-क्लिक करें।"
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "{ imageName } एम्बेड करने के लिए क्लिक करें"
  },
  "click_to_hide_preview_3c707763": {
    "message": "पूर्वावलोकन छिपाने के लिए क्लिक करें"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "संपादक में एक लिंक सम्मिलित करने के लिए क्लिक करें।"
  },
  "click_to_show_preview_faa27051": {
    "message": "पूर्वावलोकन दिखाने के लिए क्लिक करें"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "मेनू या डायलॉग बंद करें। साथ ही आपको संपादक क्षेत्र में लौटा देता है"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "पहुंच जांचकर्ता बंद करें"
  },
  "close_d634289d": {
    "message": "बंद करें"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "कुंजीपटल शॉर्टकट मोडल बंद करें"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "बंद कैप्शन फ़ाइल { maxKb } kb से कम होनी चाहिए"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "क्लोज़्ड कैप्शन/उपशीर्षक"
  },
  "clubs_suit_c1ffedff": {
    "message": "चिड़िया (ताश का रंग)"
  },
  "collab_575ac7bc": {
    "message": "कोलैब"
  },
  "collaborations_5c56c15f": {
    "message": "कोलैबोरेशंस"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "{ types } छिपाने के लिए संक्षिप्त करें"
  },
  "color_a363e1b0": {
    "message": "रंग"
  },
  "color_contrast_4c418add": {
    "message": "कलर कंट्रास्ट"
  },
  "color_contrast_ratio_687782f0": {
    "message": "कलर कंट्रास्ट अनुपात"
  },
  "color_picker_6b359edf": {
    "message": "कलर पिकर"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "कलर पिकर ({ colorName } चयनित)"
  },
  "color_popup_af39810f": {
    "message": "कलर पॉपअप"
  },
  "column_e1ae5c64": {
    "message": "स्तंभ"
  },
  "column_group_1c062368": {
    "message": "स्तंभ ग्रुप"
  },
  "complex_numbers_a543d004": {
    "message": "सम्मिश्र संख्याएं"
  },
  "computer_1d7dfa6f": {
    "message": "कंप्यूटर"
  },
  "congruent_5a244acd": {
    "message": "सर्वांगसम"
  },
  "contains_311f37b7": {
    "message": "शामिल है"
  },
  "content_1440204b": {
    "message": "सामग्री"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "संपादक में सामग्री परिवर्तित हो जाएगी। मूल सामग्री को बनाए रखने के लिए रद्द करें दबाएं।"
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "सामग्री अभी भी अपलोड की जा रही है, यदि आप जारी रखते हैं, तो इसे ठीक से एम्बेड नहीं किया जाएगा।"
  },
  "content_subtype_5ce35e88": {
    "message": "सामग्री उपप्रकार"
  },
  "content_type_2cf90d95": {
    "message": "सामग्री प्रकार"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Youtube सामग्री पर जारी रखें"
  },
  "coproduct_e7838082": {
    "message": "सह-उत्पाद"
  },
  "copyright_holder_66ee111": {
    "message": "कॉपीराइट धारक:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "सामग्री नहीं डाली जा सकी: \"{ itemType }\" आइटमें वर्तमान में Canvas में समर्थित नहीं हैं।"
  },
  "count_40eced3b": {
    "message": "गिनती करें"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 शब्द}\n    one {1 शब्द}\n  other {# शब्द}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# आइटम लोड की गई}\n  other {# आइटमें लोड की गईं}\n}"
  },
  "course_documents_104d76e0": {
    "message": "पाठ्यक्रम दस्तावेज़"
  },
  "course_files_62deb8f8": {
    "message": "पाठ्यक्रम फ़ाइलें"
  },
  "course_files_a31f97fc": {
    "message": "पाठ्यक्रम फ़ाइलें"
  },
  "course_images_f8511d04": {
    "message": "पाठ्यक्रम छवियां"
  },
  "course_link_b369426": {
    "message": "पाठ्यक्रम लिंक"
  },
  "course_links_b56959b9": {
    "message": "पाठ्यक्रम लिंक"
  },
  "course_media_ec759ad": {
    "message": "पाठ्यक्रम मीडिया"
  },
  "course_navigation_dd035109": {
    "message": "पाठ्यक्रम नेविगेशन"
  },
  "create_icon_110d6463": {
    "message": "आइकन बनाएं"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Icon Maker आइकन बनाएं"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons लाइसेंस:"
  },
  "crop_image_41bf940c": {
    "message": "छवि काटें"
  },
  "crop_image_807ebb08": {
    "message": "छवि काटें"
  },
  "cup_product_14174434": {
    "message": "कप उत्पाद"
  },
  "current_image_f16c249c": {
    "message": "वर्तमान छवि"
  },
  "current_link_945a47ee": {
    "message": "वर्तमान लिंक"
  },
  "current_volume_level_c55ab825": {
    "message": "वर्तमान वॉल्यूम स्तर"
  },
  "custom_6979cd81": {
    "message": "कस्टम"
  },
  "cyan_c1d5f68a": {
    "message": "सियान"
  },
  "dagger_57e0f4e5": {
    "message": "कटार"
  },
  "date_added_ed5ad465": {
    "message": "तिथि जोड़ी गई"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "सजावटी आइकन"
  },
  "decorative_image_fde98579": {
    "message": "सजावटी छवि"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "सजावटी { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "इंडेंट घटाएं"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "रिच कॉन्टेंट एरिया घटाएं"
  },
  "deep_purple_bb3e2907": {
    "message": "गहरा बैंगनी"
  },
  "default_9db103d": {
    "message": "डिफ़ॉल्ट"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "डिफ़ॉल्ट बुलेटेड अक्रमित सूची"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "डिफ़ॉल्ट संख्यात्मक क्रमित सूची"
  },
  "definite_integral_fe7ffed1": {
    "message": "निश्चित अभिन्न"
  },
  "degree_symbol_4a823d5f": {
    "message": "डिग्री प्रतीक"
  },
  "delimiters_4db4840d": {
    "message": "परिसीमक"
  },
  "delta_53765780": {
    "message": "डेल्टा"
  },
  "describe_the_icon_f6a18823": {
    "message": "(आइकन का वर्णन करें)"
  },
  "describe_the_type_ff448da5": {
    "message": "({ TYPE } का वर्णन करें)"
  },
  "description_436c48d7": {
    "message": "विवरण"
  },
  "details_98a31b68": {
    "message": "विवरण"
  },
  "diagonal_dots_7d71b57e": {
    "message": "विकर्ण बिंदु"
  },
  "diamond_b8dfe7ae": {
    "message": "हीरा"
  },
  "diamonds_suit_526abaaf": {
    "message": "ईंट (ताश का रंग)"
  },
  "digamma_258ade94": {
    "message": "डिगामा"
  },
  "dimension_type_f5fa9170": {
    "message": "आयाम का प्रकार"
  },
  "directionality_26ae9e08": {
    "message": "दिशात्मकता"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "LaTeX को सीधे संपादित करें"
  },
  "disable_preview_222bdf72": {
    "message": "पूर्वावलोकन अक्षम करें"
  },
  "discussion_6719c51d": {
    "message": "चर्चा"
  },
  "discussions_a5f96392": {
    "message": "चर्चाएं"
  },
  "discussions_index_6c36ced": {
    "message": "चर्चाएं सूचकांक"
  },
  "disjoint_union_e74351a8": {
    "message": "असंयुक्त संघ"
  },
  "display_options_315aba85": {
    "message": "डिस्प्ले के विकल्प"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "पाठ लिंक डिस्प्ले करें (नए टैब में खुलता है)"
  },
  "div_applied_49ad83fc": {
    "message": "डिव लागू किया गया"
  },
  "div_removed_d13f8e17": {
    "message": "डिव निकाला गया"
  },
  "division_sign_72190870": {
    "message": "विभाजन चिह्न"
  },
  "document_678cd7bf": {
    "message": "दस्तावेज़"
  },
  "documents_81393201": {
    "message": "दस्तावेज़"
  },
  "done_54e3d4b6": {
    "message": "हो गया"
  },
  "double_dagger_faf78681": {
    "message": "दोहरी कटार"
  },
  "down_5831a426": {
    "message": "नीचे"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "नीचे और बायां विकर्ण तीर"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "नीचे और दायां विकर्ण तीर"
  },
  "download_filename_2baae924": {
    "message": "{ filename } डाउनलोड करें"
  },
  "downward_arrow_cca52012": {
    "message": "अधोमुखी तीर"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "अधोमुखी त्रिभुज"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "फ़ाइल को यहां खींचें"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "खींचें और छोड़ें, या अपने कंप्यूटर को ब्राउज़ करने के लिए क्लिक करें"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "हैंडल खींचें। आकार बदलने के लिए ऊपर और नीचे तीरों का उपयोग करें"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "नियत: एकाधिक तिथियां"
  },
  "due_when_7eed10c6": {
    "message": "नियत: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "इस आइकन उदाहरण के लिए वैकल्पिक पाठ संपादित करें"
  },
  "edit_c5fbea07": {
    "message": "संपादित करें"
  },
  "edit_course_link_5a5c3c59": {
    "message": "पाठ्यक्रम लिंक संपादित करें"
  },
  "edit_equation_f5279959": {
    "message": "समीकरण संपादित करें"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "मौजूदा Icon Maker आइकन संपादित करें"
  },
  "edit_icon_2c6b0e91": {
    "message": "आइकन संपादित करें"
  },
  "edit_link_7f53bebb": {
    "message": "लिंक संपादित करें"
  },
  "editor_status_bar_653f44ee": {
    "message": "संपादक स्थिति पट्टी"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "{ start } से शुरू होता तत्व"
  },
  "embed_828fac4a": {
    "message": "एम्बेड करें"
  },
  "embed_code_314f1bd5": {
    "message": "कोड एम्बेड करें"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "बाहरी उपकरण से सामग्री एम्बेड करें"
  },
  "embed_image_1080badc": {
    "message": "छवि एम्बेड करें"
  },
  "embed_video_a97a64af": {
    "message": "वीडियो एम्बेड करें"
  },
  "embedded_content_aaeb4d3d": {
    "message": "एम्बेड की गई सामग्री"
  },
  "empty_set_91a92df4": {
    "message": "खाली सेट"
  },
  "encircled_dot_8f5e51c": {
    "message": "घिरा हुआ बिंदु"
  },
  "encircled_minus_72745096": {
    "message": "घिरा हुआ ऋण"
  },
  "encircled_plus_36d8d104": {
    "message": "घिरा हुआ घन"
  },
  "encircled_times_5700096d": {
    "message": "घिरा हुआ बार"
  },
  "engineering_icon_f8f3cf43": {
    "message": "इंजीनियरिंग आइकन"
  },
  "english_icon_25bfe845": {
    "message": "अंग्रेज़ी आइकन"
  },
  "enter_a_media_title_81b490ec": {
    "message": "मीडिया शीर्षक दर्ज करें"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "खोजने के लिए कम से कम 3 कैरेक्टर दर्ज करें"
  },
  "enter_replacement_text_17631bbc": {
    "message": "प्रतिस्थापन पाठ दर्ज करें"
  },
  "enter_search_text_26cb4459": {
    "message": "खोज पाठ दर्ज करें"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (प्रकार)"
  },
  "equals_sign_c51bdc58": {
    "message": "बराबर चिह्न"
  },
  "equation_1c5ac93c": {
    "message": "समीकरण"
  },
  "equation_editor_39fbc3f1": {
    "message": "समीकरण संपादक"
  },
  "equilibrium_6ff3040b": {
    "message": "संतुलन"
  },
  "equivalence_class_7b0f11c0": {
    "message": "समतुल्यता वर्ग"
  },
  "equivalent_identity_654b3ce5": {
    "message": "समतुल्य (पहचान)"
  },
  "eta_b8828f99": {
    "message": "एटा"
  },
  "exists_2e62bdaa": {
    "message": "मौजूद"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "फ़ुलस्क्रीन से बाहर निकलें"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "डिफ़ॉल्ट रूप से पूर्वावलोकन बढ़ाएं"
  },
  "expand_to_see_types_f5d29352": {
    "message": "{ types } देखने के लिए बढ़ाएं"
  },
  "external_link_d3f9e62a": {
    "message": "बाहरी लिंक"
  },
  "external_tool_frame_70b32473": {
    "message": "बाहरी उपकरण फ़्रेम"
  },
  "external_tools_6e77821": {
    "message": "बाहरी उपकरण"
  },
  "extra_large_b6cdf1ff": {
    "message": "ज़्यादा बड़ा"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "एक्स्ट्रा लार्ज ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "ज़्यादा छोटा"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "पाठ्येतर आइकन"
  },
  "f_function_fe422d65": {
    "message": "F (फ़ंक्शन)"
  },
  "fail_544e5dde": {
    "message": "विफल"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "फ़ाइल की सामग्री पाने में विफल"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "बाहरी उपकरण से सामग्री पुनर्प्राप्त करने में विफल"
  },
  "file_name_8fd421ff": {
    "message": "फ़ाइल नाम"
  },
  "file_preview_21667a6e": {
    "message": "फ़ाइल पूर्वावलोकन"
  },
  "file_preview_for_filename_ab314195": {
    "message": "{ fileName } के लिए फ़ाइल पूर्वावलोकन"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "फ़ाइल भंडारण कोटा सीमा से अधिक हुआ"
  },
  "file_url_c12b64be": {
    "message": "फ़ाइल URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } फ़ाइल आइकन"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } छवि पूर्वावलोकन"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } पाठ पूर्वावलोकन"
  },
  "files_c300e900": {
    "message": "फ़ाइलें"
  },
  "files_index_af7c662b": {
    "message": "फ़ाइल सूचकांक"
  },
  "find_8d605019": {
    "message": "ढूंढें"
  },
  "find_and_replace_6e345933": {
    "message": "ढूंढें और बदलें"
  },
  "finish_bc343002": {
    "message": "खत्म करें"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "हेडिंग पदानुक्रम ठीक करें"
  },
  "flat_music_76d5a5c3": {
    "message": "फ़्लैट (संगीत)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "फ़ोकस तत्व विकल्प उपकरण पट्टी"
  },
  "folder_tree_fbab0726": {
    "message": "फ़ोल्डर ट्री"
  },
  "for_all_b919f972": {
    "message": "सभी के लिए"
  },
  "format_4247a9c5": {
    "message": "प्रारूप"
  },
  "format_as_a_list_142210c3": {
    "message": "सूची के रूप में प्रारूपित करें"
  },
  "formatting_5b143aa8": {
    "message": "प्रारूपित किया जा रहा है"
  },
  "forward_slash_3f90f35e": {
    "message": "फ़ॉरवर्ड स्लैश"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "स्वतः सहेजी गई सामग्री मिली"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "{ count, plural,\n     =0 {# नतीजे}\n    one {# नतीजा}\n  other {# नतीजे}\n} मिले"
  },
  "fraction_41bac7af": {
    "message": "भिन्न"
  },
  "fullscreen_873bf53f": {
    "message": "फ़ुलस्क्रीन"
  },
  "gamma_1767928": {
    "message": "गामा"
  },
  "generating_preview_45b53be0": {
    "message": "पूर्वावलोकन जेनरेट किया जा रहा है..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "{ size } KB से बड़ी GIF/PNG प्रारूप वाली छवियां वर्तमान में समर्थित नहीं हैं।"
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "संपादक की मेनू पट्टी पर जाएं"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "संपादक की उपकरण पट्टी पर जाएं"
  },
  "grades_a61eba0a": {
    "message": "ग्रेड"
  },
  "graphics_text_bc9568bc": {
    "message": "ग्राफ़िक पाठ"
  },
  "greater_than_e98af662": {
    "message": "इससे अधिक:"
  },
  "greater_than_or_equal_b911949a": {
    "message": "इससे अधिक या बराबर:"
  },
  "greek_65c5b3f7": {
    "message": "ग्रीक"
  },
  "green_15af4778": {
    "message": "हरा"
  },
  "grey_a55dceff": {
    "message": "सलेटी"
  },
  "group_documents_8bfd6ae6": {
    "message": "ग्रुप दस्तावेज़"
  },
  "group_files_4324f3df": {
    "message": "ग्रुप फ़ाइलें"
  },
  "group_files_82e5dcdb": {
    "message": "ग्रुप फ़ाइल"
  },
  "group_images_98e0ac17": {
    "message": "ग्रुप छवियां"
  },
  "group_isomorphism_45b1458c": {
    "message": "ग्रुप समरूपता"
  },
  "group_link_63e626b3": {
    "message": "ग्रुप लिंक"
  },
  "group_links_9493129e": {
    "message": "ग्रुप लिंक"
  },
  "group_media_2f3d128a": {
    "message": "ग्रुप मीडिया"
  },
  "group_navigation_99f191a": {
    "message": "ग्रुप नेविगेशन "
  },
  "h_bar_bb94deae": {
    "message": "H पट्टी"
  },
  "hat_ea321e35": {
    "message": "हैट"
  },
  "header_column_f27433cb": {
    "message": "हेडर स्तंभ"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "हेडर पंक्ति और स्तंभ"
  },
  "header_row_f33eb169": {
    "message": "हेडर पंक्ति"
  },
  "heading_2_5b84eed2": {
    "message": "हेडिंग 2"
  },
  "heading_3_2c83de44": {
    "message": "हेडिंग 3"
  },
  "heading_4_b2e74be7": {
    "message": "हेडिंग 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "हेडिंग { h } लागू किया गया"
  },
  "heading_h_removed_745f24a6": {
    "message": "हेडिंग { h } निकाला गया"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "हेडिंग स्तरों को छोड़ा नहीं जाना चाहिए।"
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "{ start } से शुरू होती हेडिंग"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "हेडिंग में 120 से अधिक कैरेक्टर नहीं होने चाहिए।"
  },
  "health_icon_8d292eb5": {
    "message": "स्वास्थ्य आइकन"
  },
  "hearts_suit_e50e04ca": {
    "message": "पान (ताश का रंग)"
  },
  "height_69b03e15": {
    "message": "ऊंचाई"
  },
  "hexagon_d8468e0d": {
    "message": "षटकोण"
  },
  "hide_description_bfb5502e": {
    "message": "विवरण छिपाएं"
  },
  "hide_title_description_caf092ef": {
    "message": "{ title } विवरण छिपाएं"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "तत्व विकल्प उपकरण पट्टी को सक्रिय करने के लिए किसी तत्व को हाइलाइट करें"
  },
  "home_351838cd": {
    "message": "होम"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "कैप्शन का अनुरोध और संपादन कैसे करें?"
  },
  "html_code_editor_fd967a44": {
    "message": "HTML कोड संपादक"
  },
  "html_editor_fb2ab713": {
    "message": "HTML संपादक"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "मैंने इस फ़ाइल का उपयोग करने की अनुमति प्राप्त कर ली है।"
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "मेरे पास कॉपीराइट है"
  },
  "icon_215a1dc6": {
    "message": "आइकन"
  },
  "icon_8168b2f8": {
    "message": "आइकन"
  },
  "icon_color_b86dd6d6": {
    "message": "आइकन रंग"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Icon Maker आइकन"
  },
  "icon_options_7e32746e": {
    "message": "आइकन विकल्प"
  },
  "icon_options_tray_2b407977": {
    "message": "आइकन विकल्प ट्रे"
  },
  "icon_preview_1782a1d9": {
    "message": "आइकन पूर्वावलोकन"
  },
  "icon_shape_30b61e7": {
    "message": "आइकन का आकार"
  },
  "icon_size_9353edea": {
    "message": "आइकन का साइज़"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "यदि खाली छोड़ दिया जाए, तो लिंक पाठ पाठ्यक्रम लिंक नाम के रूप में प्रदर्शित होगा"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "यदि उपयोग अधिकारों की आवश्यकता है, तो फ़ाइल पेज में सक्षम होने तक फ़ाइल प्रकाशित नहीं होगी।"
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "यदि आप अभी उपयोग अधिकार का चयन नहीं करते हैं, तो यह फ़ाइल अपलोड होने के बाद अप्रकाशित हो जाएगी।"
  },
  "image_8ad06": {
    "message": "छवि"
  },
  "image_c1c98202": {
    "message": "छवि"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "छवि फ़ाइल नामों का उपयोग छवि सामग्री का वर्णन करने वाले वैकल्पिक एट्रिब्यूट के रूप में नहीं किया जाना चाहिए।"
  },
  "image_options_5412d02c": {
    "message": "छवि विकल्प"
  },
  "image_options_tray_90a46006": {
    "message": "छवि विकल्प ट्रे"
  },
  "image_to_crop_3a34487d": {
    "message": "काटने के लिए छवि"
  },
  "image_with_filename_file_aacd7180": {
    "message": "फ़ाइल नाम { file } वाली छवि"
  },
  "images_7ce26570": {
    "message": "छवियां"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "छवियों में छवि सामग्री का वर्णन करने वाला एक वैकल्पिक एट्रिब्यूट शामिल होना चाहिए।"
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "काल्पनिक भाग (सम्मिश्र संख्या का)"
  },
  "in_element_of_19ca2f33": {
    "message": "में (इसका तत्व)"
  },
  "increase_indent_6af90f7c": {
    "message": "इंडेंट बढ़ाएं"
  },
  "increase_rich_content_area_340b775": {
    "message": "रिच कॉन्टेंट एरिया बढ़ाएं"
  },
  "indefinite_integral_6623307e": {
    "message": "अनिश्चित अभिन्न"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ max }में से { index }"
  },
  "indigo_2035fc55": {
    "message": "इंडिगो"
  },
  "inference_fed5c960": {
    "message": "अनुमान"
  },
  "infinity_7a10f206": {
    "message": "अनंत"
  },
  "input_field_for_alpha_678265fd": {
    "message": "अल्फ़ा के लिए फ़ील्ड दर्ज करें"
  },
  "input_field_for_blue_561e020a": {
    "message": "नीले के लिए फ़ील्ड दर्ज करें"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "हरे के लिए फ़ील्ड दर्ज करें"
  },
  "input_field_for_red_86a84615": {
    "message": "लाल के लिए फ़ील्ड दर्ज करें"
  },
  "insert_593145ef": {
    "message": "डालें"
  },
  "insert_link_6dc23cae": {
    "message": "लिंक डालें"
  },
  "insert_math_equation_57c6e767": {
    "message": "गणित का समीकरण डालें"
  },
  "integers_336344e1": {
    "message": "पूर्णांक"
  },
  "intersection_cd4590e4": {
    "message": "प्रतिच्छेदन"
  },
  "invalid_description_991e23bb": {
    "message": "अमान्य विवरण"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "अमान्य प्रविष्टि।"
  },
  "invalid_file_c11ba11": {
    "message": "अमान्य फ़ाइल"
  },
  "invalid_file_type_881cc9b2": {
    "message": "अमान्य फ़ाइल प्रकार"
  },
  "invalid_url_cbde79f": {
    "message": "अमान्य URL"
  },
  "iota_11c932a9": {
    "message": "आयोटा"
  },
  "issue_num_total_f94536cf": {
    "message": "समस्या { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "इटैलिक लागू किया गया"
  },
  "italic_removed_17cbab6f": {
    "message": "इटैलिक निकाला गया"
  },
  "kappa_2f14c816": {
    "message": "कप्पा"
  },
  "kappa_variant_eb64574b": {
    "message": "कप्पा (प्रकार)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "कुंजीपटल शॉर्टकट"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "टैब कुंजी का उपयोग करके कुंजीपटल लिंक पर नेविगेट करते हैं। एक ही गंतव्य की ओर निर्देशित दो आसन्न लिंक कुंजीपटल उपयोगकर्ताओं को भ्रमित कर सकते हैं।"
  },
  "lambda_4f602498": {
    "message": "लैम्ब्डा"
  },
  "language_arts_icon_a798b0f8": {
    "message": "भाषा कला आइकन"
  },
  "languages_icon_9d20539": {
    "message": "भाषाएं आइकन"
  },
  "large_9c5e80e7": {
    "message": "बड़ा"
  },
  "large_text_e7ba08cd": {
    "message": "बड़ा पाठ"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "लार्ज ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "सीखें"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "निकटवर्ती लिंक के बारे में और जानें"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "रंगों के कंट्रास्ट के बारे में और जानें"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "पेज हेडिंग को व्यवस्थित करने के बारे में और जानें"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "उचित पेज हेडिंग संरचना के बारे में और जानें"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "तालिका के हेडर के बारे में और जानें"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "छवियों के लिए वैकल्पिक पाठ का उपयोग करने के बारे में और जानें"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "तालिकाओं के साथ कैप्शन का उपयोग करने के बारे में और जानें"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "फ़ाइल नामों को वैकल्पिक पाठ के रूप में उपयोग करने के बारे में और जानें"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "सूचियों के उपयोग के बारे में और जानें"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "तालिकाओं के साथ स्कोप एट्रिब्यूट का उपयोग करने के बारे में और जानें"
  },
  "leave_as_is_4facfe55": {
    "message": "जैसा है वैसा ही छोड़ दें"
  },
  "left_3ea9d375": {
    "message": "बायां"
  },
  "left_align_43d95491": {
    "message": "बायां संरेखित"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "बायां कोण कोष्ठक"
  },
  "left_arrow_4fde1a64": {
    "message": "बायां तीर"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "हुक वाला बायां तीर"
  },
  "left_ceiling_ee9dd88a": {
    "message": "बाईं सीमा"
  },
  "left_curly_brace_1726fb4": {
    "message": "बायां धनु कोष्ठक"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "बायां अधोमुखी हार्पून तीर"
  },
  "left_floor_29ac2274": {
    "message": "बायां फ़र्श"
  },
  "left_to_right_e9b4fd06": {
    "message": "बाएं से दाएं"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "बायां उर्ध्वगामी हार्पून तीर"
  },
  "leftward_arrow_1e4765de": {
    "message": "बायां मुखी तीर"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "बायां मुखी त्रिभुज"
  },
  "less_than_a26c0641": {
    "message": "इससे कम:"
  },
  "less_than_or_equal_be5216cb": {
    "message": "इससे कम या बराबर:"
  },
  "library_icon_ae1e54cf": {
    "message": "लाइब्रेरी आइकन"
  },
  "light_blue_5374f600": {
    "message": "हल्का नीला"
  },
  "link_7262adec": {
    "message": "लिंक"
  },
  "link_options_a16b758b": {
    "message": "लिंक विकल्प"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "लिंक प्रकार: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "{ start } से शुरू होने वाले पाठ के साथ लिंक करें"
  },
  "links_14b70841": {
    "message": "लिंक"
  },
  "links_to_an_external_site_de74145d": {
    "message": "बाहरी साइट के लिए लिंक।"
  },
  "lists_cd1336fc": {
    "message": "सूचियां"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "सूचियों को सूचियों के रूप में स्वरूपित किया जाना चाहिए।"
  },
  "load_more_35d33c7": {
    "message": "और अधिक लोड करें"
  },
  "loading_25990131": {
    "message": "लोड किया जा रहा है..."
  },
  "loading_bde52856": {
    "message": "लोड किया जा रहा है"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "क्लोज़्ड कैप्शन/उपशीर्षक लोड करना विफल रहा।"
  },
  "loading_external_tool_d839042c": {
    "message": "बाहरी उपकरण लोड किया जा रहा है"
  },
  "loading_failed_b3524381": {
    "message": "लोड करना विफल रहा..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "लोड करना विफल रहा।"
  },
  "loading_folders_d8b5869e": {
    "message": "फ़ोल्डर लोड किए जा रहे हैं"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "{ fileName } के लिए प्लेसहोल्डर लोड किया जा रहा है"
  },
  "loading_please_wait_d276220a": {
    "message": "लोड किया जा रहा है, कृपया प्रतीक्षा करें"
  },
  "loading_preview_9f077aa1": {
    "message": "पूर्वावलोकन लोड किया जा रहा है"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "1x पर गति लॉक कर दें"
  },
  "locked_762f138b": {
    "message": "लॉक किया गया"
  },
  "logical_equivalence_76fca396": {
    "message": "तार्किक समतुल्यता"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "तार्किक समतुल्यता (छोटी)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "तार्किक समतुल्यता (छोटी और मोटी)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "तार्किक समतुल्यता (मोटी)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "निम्न क्षैतिज बिंदु"
  },
  "magenta_4a65993c": {
    "message": "मैजेंटा"
  },
  "maps_to_e5ef7382": {
    "message": "इससे मैप करता है"
  },
  "math_icon_ad4e9d03": {
    "message": "गणित आइकन"
  },
  "media_af190855": {
    "message": "मीडिया"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "मीडिया फ़ाइल प्रोसेस हो रही है। कृपया बाद में फिर से कोशिश करें।"
  },
  "media_options_saved_560c4ec8": {
    "message": "मीडिया विकल्प सहेजे गए।"
  },
  "media_title_2112243b": {
    "message": "मीडिया शीर्षक"
  },
  "medium_5a8e9ead": {
    "message": "मध्यम"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "मीडियम ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "लिंक मर्ज करें"
  },
  "mic_a7f3d311": {
    "message": "माइक"
  },
  "microphone_disabled_15c83130": {
    "message": "माइक्रोफ़ोन अक्षम किया गया"
  },
  "middle_27dc1d5": {
    "message": "मध्य"
  },
  "minimize_file_preview_da911944": {
    "message": "फ़ाइल पूर्वावलोकन न्यूनतम करें"
  },
  "minimize_video_20aa554b": {
    "message": "वीडियो न्यूनतम करें"
  },
  "minus_fd961e2e": {
    "message": "ऋण"
  },
  "minus_plus_3461f637": {
    "message": "ऋण/घन"
  },
  "misc_3b692ea7": {
    "message": "विविध"
  },
  "miscellaneous_e9818229": {
    "message": "विविध"
  },
  "module_90d9fd32": {
    "message": "मॉड्यूल"
  },
  "modules_c4325335": {
    "message": "मॉड्यूल"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "{ directionWord } को काटने के लिए छवि को स्थानांतरित किया जा रहा है"
  },
  "mu_37223b8b": {
    "message": "म्यू"
  },
  "multi_color_image_63d7372f": {
    "message": "बहुरंगी छवि"
  },
  "multiplication_sign_15f95c22": {
    "message": "गुणन चिह्न"
  },
  "music_icon_4db5c972": {
    "message": "संगीत आइकन"
  },
  "my_files_2f621040": {
    "message": "मेरी फ़ाइलें"
  },
  "n_th_root_9991a6e4": {
    "message": "Nवां मूल"
  },
  "nabla_1e216d25": {
    "message": "नाबला"
  },
  "name_1aed4a1b": {
    "message": "नाम"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "प्राकृतिक (संगीत)"
  },
  "natural_numbers_3da07060": {
    "message": "प्राकृतिक संख्याएं"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "मेनू या उपकरण पट्टी के माध्यम से नेविगेट करें"
  },
  "navigation_ee9af92d": {
    "message": "नेविगेशन"
  },
  "nested_greater_than_d852e60d": {
    "message": "नीडिंत प्रविष्ट इससे अधिक:"
  },
  "nested_less_than_27d17e58": {
    "message": "नीडिंत प्रविष्ट इससे कम:"
  },
  "new_quiz_34aacba6": {
    "message": "नई प्रश्नोत्तरी"
  },
  "next_40e12421": {
    "message": "अगला"
  },
  "next_findtext_9d69f0fe": {
    "message": "अगला { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "कोई पहुंच संबंधी समस्या नहीं मिली।"
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "अभी तक कोई घोषणा नहीं बनाई गई।"
  },
  "no_announcements_found_20185afc": {
    "message": "कोई घोषणा नहीं मिली।"
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "अभी तक कोई असाइनमेंट नहीं बनाई गई।"
  },
  "no_assignments_found_79e46d7f": {
    "message": "कोई असाइनमेंट नहीं मिली।"
  },
  "no_changes_to_save_d29f6e91": {
    "message": "सहेजने के लिए कोई बदलाव नहीं।"
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "अभी तक कोई चर्चा नहीं बनाई गई।"
  },
  "no_discussions_found_9284063b": {
    "message": "कोई चर्चा नहीं मिली।"
  },
  "no_e16d9132": {
    "message": "नहीं"
  },
  "no_file_chosen_9a880793": {
    "message": "कोई फ़ाइल नहीं चुनी गई"
  },
  "no_headers_9bc7dc7f": {
    "message": "कोई हेडर नहीं"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "अभी तक कोई मॉड्यूल नहीं बनाया गया।"
  },
  "no_modules_found_2df43a40": {
    "message": "कोई मॉड्यूल नहीं मिला।"
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "अभी तक कोई पेज नहीं बनाया गया।"
  },
  "no_pages_found_6799350": {
    "message": "कोई पेज नहीं मिला।"
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "इस फ़ाइल के लिए कोई पूर्वावलोकन उपलब्ध नहीं है।"
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "अभी तक कोई प्रश्नोत्तरी नहीं बनाई गई।"
  },
  "no_quizzes_found_c80c537a": {
    "message": "कोई प्रश्नोत्तरी नहीं मिली।"
  },
  "no_results_940393cf": {
    "message": "कोई नतीजा नहीं।"
  },
  "no_results_found_58717065": {
    "message": "कोई नतीजा नहीं मिला"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "{ filterTerm } के लिए कोई नतीजा नहीं मिला"
  },
  "no_video_1ed00b26": {
    "message": "कोई वीडियो नहीं"
  },
  "none_3b5e34d2": {
    "message": "कोई नहीं"
  },
  "none_selected_b93d56d2": {
    "message": "कोई भी चयनित नहीं"
  },
  "normal_text_7b03da48": {
    "message": "सामान्य पाठ"
  },
  "not_equal_6e2980e6": {
    "message": "समान नहीं"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "इसमें में नहीं (इसका एक तत्व नहीं)"
  },
  "not_negation_1418ebb8": {
    "message": "नहीं (नकारात्मक)"
  },
  "not_subset_dc2b5e84": {
    "message": "उपसमुच्चय नहीं"
  },
  "not_subset_strict_23d282bf": {
    "message": "उपसमुच्चय नहीं (विशुद्ध)"
  },
  "not_superset_5556b913": {
    "message": "अधिसमुच्चय नहीं"
  },
  "not_superset_strict_24e06f36": {
    "message": "सुपरसेट नहीं (विशुद्ध)"
  },
  "nu_1c0f6848": {
    "message": "न्यू"
  },
  "octagon_e48be9f": {
    "message": "अष्टकोण"
  },
  "olive_6a3e4d6b": {
    "message": "जैतून"
  },
  "omega_8f2c3463": {
    "message": "ओमेगा"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "किसी आइकन को सहेजने के लिए निम्नलिखित शैलियों में से एक को जोड़ा जाना चाहिए: आइकन रंग, रूपरेखा साइज़, आइकन पाठ, या छवि"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "एक या अधिक फ़ाइलें पेस्ट करने में विफल रहीं। कृपया फ़ाइलें अपलोड करने या खींचने और छोड़ने का प्रयास करें।"
  },
  "open_circle_e9bd069": {
    "message": "वृत्त खोलें"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "इस कुंजीपटल शॉर्टकट डायलॉग को खोलें"
  },
  "open_title_application_fd624fc5": {
    "message": "{ title } ऐप्लिकेशन खोलें"
  },
  "operators_a2ef9a93": {
    "message": "ऑपरेटर"
  },
  "options_3ab0ea65": {
    "message": "विकल्प"
  },
  "or_9b70ccaa": {
    "message": "या"
  },
  "orange_81386a62": {
    "message": "नारंगी"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "क्रमित और अक्रमित सूचियां"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "अन्य संपादक शॉर्टकट यहां पाए जा सकते हैं:"
  },
  "outline_color_3ef2cea7": {
    "message": "रूपरेखा रंग"
  },
  "outline_size_a6059a21": {
    "message": "रूपरेखा साइज़"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } मान्य प्रोटोकॉल नहीं है।"
  },
  "page_50c4823d": {
    "message": "पेज"
  },
  "pages_e5414c2c": {
    "message": "पेज"
  },
  "paragraph_5e5ad8eb": {
    "message": "पैराग्राफ़"
  },
  "paragraph_applied_959b3fe5": {
    "message": "पैराग्राफ़ लागू किया गया"
  },
  "paragraph_removed_d09320e": {
    "message": "पैराग्राफ़ निकाला गया"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "{ start } से शुरू होता पैराग्राफ़"
  },
  "parallel_d55d6e38": {
    "message": "समानांतर"
  },
  "partial_derivative_4a9159df": {
    "message": "आंशिक (यौगिक)"
  },
  "pass_1c19a2b3": {
    "message": "पास"
  },
  "paste_5963d1c1": {
    "message": "पेस्ट करें"
  },
  "pause_12af3bb4": {
    "message": "पॉज़ करें"
  },
  "pentagon_17d82ea3": {
    "message": "पंचकोण"
  },
  "people_b4ebb13c": {
    "message": "लोग"
  },
  "percentage_34ab7c2c": {
    "message": "प्रतिशत"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "प्रतिशत संख्या होनी चाहिए"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "प्रतिशत कम से कम { percentage }% होना चाहिए"
  },
  "performing_arts_icon_f3497486": {
    "message": "प्रदर्शन कला आइकन"
  },
  "perpendicular_7c48ede4": {
    "message": "लंबवत"
  },
  "phi_4ac33b6d": {
    "message": "फ़ाई"
  },
  "phi_variant_c9bb3ac5": {
    "message": "फ़ाई (प्रकार)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "शारीरिक शिक्षा आइकन"
  },
  "pi_dc4f0bd8": {
    "message": "पाई"
  },
  "pi_variant_10f5f520": {
    "message": "पाई (प्रकार)"
  },
  "pick_a_color_557abfb0": {
    "message": "कोई रंग चुनें"
  },
  "pink_68ad45cb": {
    "message": "गुलाबी"
  },
  "pixels_52ece7d1": {
    "message": "पिक्सल"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "पिक्सल कम से कम { width } x { height }px होने चाहिए"
  },
  "play_1a47eaa7": {
    "message": "चलाएं"
  },
  "play_media_comment_35257210": {
    "message": "मीडिया टिप्पणी चलाएं।"
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "{ createdAt } से { name } द्वारा मीडिया टिप्पणी चलाएं।"
  },
  "player_layout_14e09a29": {
    "message": "प्लेयर लेआउट"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "कृपया Canvas को अपने माइक्रोफ़ोन और वेबकैम के लिए एक्सेस की अनुमति दें।"
  },
  "please_choose_a_file_c2449cc": {
    "message": "कृपया कोई फ़ाइल चुनें"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "कृपया फ़ाइल नाम दर्ज करें"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "कृपया समर्थित प्लेटफ़ॉर्म से मान्य वीडियो URL दर्ज करें।"
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "कृपया समर्थित प्रकार की फ़ाइल चुनें"
  },
  "plus_d43cd4ec": {
    "message": "घन"
  },
  "plus_minus_f8be2e83": {
    "message": "घन/ऋण"
  },
  "posted_when_a578f5ab": {
    "message": "पोस्ट किया गया: { when }"
  },
  "power_set_4f26f316": {
    "message": "पॉवर सेट"
  },
  "precedes_196b9aef": {
    "message": "पूर्ववर्ती"
  },
  "precedes_equal_20701e84": {
    "message": "समान से पूर्ववर्ती"
  },
  "preformatted_d0670862": {
    "message": "पूर्वस्वरूपित"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "पिछला"
  },
  "preview_53003fd2": {
    "message": "पूर्वावलोकन"
  },
  "preview_a3f8f854": {
    "message": "पूर्वावलोकन"
  },
  "preview_in_overlay_ed772c46": {
    "message": "ओवरले में पूर्वावलोकन करें"
  },
  "preview_inline_9787330": {
    "message": "इनलाइन पूर्वावलोकन करें"
  },
  "previous_bd2ac015": {
    "message": "पिछला"
  },
  "previous_findtext_8dfbfd30": {
    "message": "पिछला { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "पहले चुने गए रंग"
  },
  "prime_917ea60e": {
    "message": "अभाज्य"
  },
  "prime_numbers_13464f61": {
    "message": "अभाज्य संख्याएं"
  },
  "product_39cf144f": {
    "message": "उत्पाद"
  },
  "proportional_f02800cc": {
    "message": "आनुपातिक"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": " प्रोटोकॉल ftp, http, https, mailto, skype, tel होनी चाहिए या छोड़ा जा सकता है"
  },
  "psi_e3f5f0f7": {
    "message": "साई"
  },
  "published_c944a23d": {
    "message": "प्रकाशित हुआ"
  },
  "published_when_302d8e23": {
    "message": "प्रकाशित हुआ: { when }"
  },
  "pumpkin_904428d5": {
    "message": "कद्दू"
  },
  "purple_7678a9fc": {
    "message": "बैंगनी"
  },
  "quaternions_877024e0": {
    "message": "चतुष्क"
  },
  "quiz_e0dcce8f": {
    "message": "प्रश्नोत्तरी"
  },
  "quizzes_7e598f57": {
    "message": "प्रश्नोत्तरी"
  },
  "rational_numbers_80ddaa4a": {
    "message": "परिमेय संख्याएं"
  },
  "real_numbers_7c99df94": {
    "message": "वास्तविक संख्याएं"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "वास्तविक भाग (सम्मिश्र संख्या का)"
  },
  "record_7c9448b": {
    "message": "रिकॉर्ड करें"
  },
  "record_upload_media_5fdce166": {
    "message": "मीडिया रिकॉर्ड / अपलोड करें"
  },
  "recording_98da6bda": {
    "message": "रिकॉर्डिंग"
  },
  "red_8258edf3": {
    "message": "लाल"
  },
  "relationships_6602af70": {
    "message": "संबंध"
  },
  "religion_icon_246e0be1": {
    "message": "धर्म आइकन"
  },
  "remove_f47dc62a": {
    "message": "निकालें"
  },
  "remove_filename_3ea029f6": {
    "message": "{ filename } निकालें"
  },
  "remove_heading_style_5fdc8855": {
    "message": "हेडिंग शैली निकालें"
  },
  "remove_link_d1f2f4d0": {
    "message": "लिंक निकालें"
  },
  "replace_all_d3d68b3": {
    "message": "सभी को प्रतिस्थापित करें"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "सभी{ findText } को { replaceText } से प्रतिस्थापित करें"
  },
  "replace_e61834a7": {
    "message": "प्रतिस्थापित करें"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "{ findText }को { replaceText } से प्रतिस्थापित करें"
  },
  "replace_with_eeff01ad": {
    "message": "इसके साथ प्रतिस्थापित करें:"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "{ alertFindText }को { alertReplaceText } से प्रतिस्थापित किया गया"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "सभी{ alertFindText } को { alertReplaceText } से प्रतिस्थापित किया गया"
  },
  "reset_95a81614": {
    "message": "रीसेट करें"
  },
  "resize_ec83d538": {
    "message": "साइज़ बदलें"
  },
  "restore_auto_save_deccd84b": {
    "message": "स्वत: सहेजें पुनर्स्थापित करें?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "कुल{ max } में से { index } नतीजा।"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "रिवर्स टर्नस्टाइल (प्रतिफल नहीं देता)"
  },
  "rho_a0244a36": {
    "message": "रो"
  },
  "rho_variant_415245cd": {
    "message": "रो (प्रकार)"
  },
  "rich_content_editor_2708ef21": {
    "message": "रिच कॉन्टेंट संपादक"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "रिच टेक्स्ट एरिया। रिच कॉन्टेंट संपादक शॉर्टकट के लिए { OSKey }+F8 दबाएं।"
  },
  "right_71ffdc4d": {
    "message": "दायां"
  },
  "right_align_39e7a32a": {
    "message": "दायां संरेखित"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "दायां कोण कोष्ठक"
  },
  "right_arrow_35e0eddf": {
    "message": "दायां तीर"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "हुक वाला दायां तीर"
  },
  "right_ceiling_839dc744": {
    "message": "दाईं सीमा"
  },
  "right_curly_brace_5159d5cd": {
    "message": "दायां धनु कोष्ठक"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "दायां अधोमुखी हार्पून तीर"
  },
  "right_floor_5392d5cf": {
    "message": "दायां फ़र्श"
  },
  "right_to_left_9cfb092a": {
    "message": "दाएं से बाएं"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "दायां उर्ध्वगामी हार्पून तीर"
  },
  "rightward_arrow_32932107": {
    "message": "दायां मुखी तीर"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "दायां मुखी त्रिभुज"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "छवि को -90 डिग्री घुमाएं"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "छवि को 90 डिग्री घुमाएं"
  },
  "rotation_9699c538": {
    "message": "घूर्णन"
  },
  "row_fc0944a7": {
    "message": "पंक्ति"
  },
  "row_group_979f5528": {
    "message": "पंक्ति ग्रुप"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "अफसोस की बात है कि सुंदर HTML संपादक में कुंजीपटल इस्तेमाल नहीं किया जा सकता। सुंदर HTML संपादक एक्सेस करें।"
  },
  "save_11a80ec3": {
    "message": "सहेजें"
  },
  "save_copy_ca63944e": {
    "message": "कॉपी सहेजें"
  },
  "save_media_cb9e786e": {
    "message": "मीडिया सहेजें"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Icon Maker आइकन सहेजें"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "स्क्रीन रीडर यह निर्धारित नहीं कर सकते कि वैकल्पिक पाठ के बिना किसी छवि में क्या प्रदर्शित किया गया है, और फ़ाइल नाम अक्सर संख्याओं और अक्षरों की अर्थहीन स्ट्रिंग होते हैं जो संदर्भ या अर्थ का वर्णन नहीं करते हैं।"
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "स्क्रीन रीडर वैकल्पिक पाठ के बिना यह निर्धारित नहीं कर सकते कि छवि में क्या प्रदर्शित है, जो छवि की सामग्री और अर्थ का वर्णन करता है। वैकल्पिक पाठ सरल एवं संक्षिप्त होना चाहिए।"
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "स्क्रीन रीडर वैकल्पिक पाठ के बिना यह निर्धारित नहीं कर सकते कि छवि में क्या प्रदर्शित है, जो छवि की सामग्री और अर्थ का वर्णन करता है।"
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "स्क्रीन रीडर उचित संरचना के बिना तालिकाओं की व्याख्या नहीं कर सकते। तालिका हेडर दिशा और सामग्री क्षेत्र प्रदान करते हैं।"
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "स्क्रीन रीडर उचित संरचना के बिना तालिकाओं की व्याख्या नहीं कर सकते। तालिका कैप्शन तालिका के संदर्भ और सामान्य समझ का वर्णन करते हैं।"
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "स्क्रीन रीडर उचित संरचना के बिना तालिकाओं की व्याख्या नहीं कर सकते। तालिका हेडर सामग्री की दिशा और अवलोकन प्रदान करते हैं।"
  },
  "script_l_42a7b254": {
    "message": "स्क्रिप्ट L"
  },
  "search_280d00bd": {
    "message": "खोजें"
  },
  "select_audio_source_21043cd5": {
    "message": "ऑडियो स्रोत चुनें"
  },
  "select_crop_shape_d441feeb": {
    "message": "आकार काटें चुनें"
  },
  "select_language_7c93a900": {
    "message": "भाषा चुनें"
  },
  "select_video_source_1b5c9dbe": {
    "message": "वीडियो स्रोत चुनें"
  },
  "selected_274ce24f": {
    "message": "चुना गया"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "{ linkFileName } चुना गया"
  },
  "selection_b52c4c5e": {
    "message": "चयन"
  },
  "set_header_scope_8c548f40": {
    "message": "हेडर क्षेत्र सेट करें"
  },
  "set_minus_b46e9b88": {
    "message": "ऋण सेट करें"
  },
  "set_table_header_cfab13a0": {
    "message": "तालिका हेडर सेट करें"
  },
  "sharp_music_ab956814": {
    "message": "Sharp (संगीत)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+तीर"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O दबा कर सुंदर HTML संपादक खोलें"
  },
  "shortcut_911d6255": {
    "message": "शॉर्टकट"
  },
  "show_image_options_1e2ecc6b": {
    "message": "छवि विकल्प दिखाएं"
  },
  "show_link_options_545338fd": {
    "message": "लिंक विकल्प दिखाएं"
  },
  "show_rolling_transcript_c1481744": {
    "message": "रोलिंग ट्रांसक्रिप्ट दिखाएं"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "रोलिंग ट्रांसक्रिप्ट दिखाएं"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "दृष्टिबाधित उपयोगकर्ता बड़ी या बोल्ड हेडिंग की तलाश में तेज़ी से वेब पेज ब्राउज़ करते हैं। स्क्रीन रीडर उपयोगकर्ता प्रासंगिक समझ के लिए हेडर पर भरोसा करते हैं। हेडर को उचित संरचना का उपयोग करना चाहिए।"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "दृष्टिबाधित उपयोगकर्ता बड़ी या बोल्ड हेडिंग की तलाश में तेज़ी से वेब पेज ब्राउज़ करते हैं। स्क्रीन रीडर उपयोगकर्ता प्रासंगिक समझ के लिए हेडर पर भरोसा करते हैं। हेडर उचित संरचना के भीतर संक्षिप्त होने चाहिए।"
  },
  "sigma_5c35e553": {
    "message": "सिग्मा"
  },
  "sigma_variant_8155625": {
    "message": "सिग्मा (प्रकार)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "एकल रंग वाली छवि"
  },
  "single_color_image_color_95fa9a87": {
    "message": "एकल रंग वाला छवि रंग"
  },
  "size_b30e1077": {
    "message": "साइज़"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "कैप्शन फ़ाइल का साइज़ अधिकतम { max } KB अनुमत फ़ाइल साइज़ से अधिक है।"
  },
  "small_b070434a": {
    "message": "छोटा"
  },
  "small_width_x_height_px_359acd38": {
    "message": "स्मॉल ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "ठोस वृत्त"
  },
  "something_went_wrong_89195131": {
    "message": "कुछ गड़बड़ हुई।"
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "आपका वेबकैम एक्सेस करते समय कुछ गड़बड़ हुई।"
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "कुछ गलत हो गया और मुझे नहीं पता कि आपको क्या दिखाऊं।"
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "कुछ गड़बड़ हुई। अपना कनेक्शन जांचें, पेज पुनः लोड करें और पुनः प्रयास करें।"
  },
  "something_went_wrong_d238c551": {
    "message": "कुछ गड़बड़ हुई"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "आपकी स्क्रीन साझा करते समय कुछ गड़बड़ हुई।"
  },
  "sort_by_e75f9e3e": {
    "message": "इस के आधार पर क्रमबद्ध करें"
  },
  "spades_suit_b37020c2": {
    "message": "हुकुम (ताश का रंग)"
  },
  "square_511eb3b3": {
    "message": "वर्ग"
  },
  "square_cap_9ec88646": {
    "message": "वर्ग कैप"
  },
  "square_cup_b0665113": {
    "message": "वर्ग कप"
  },
  "square_root_e8bcbc60": {
    "message": "वर्ग मूल"
  },
  "square_root_symbol_d0898a53": {
    "message": "वर्ग मूल प्रतीक"
  },
  "square_subset_17be67cb": {
    "message": "वर्ग उपसमुच्चय"
  },
  "square_subset_strict_7044e84f": {
    "message": "वर्ग उपसमुच्चय (विशुद्ध)"
  },
  "square_superset_3be8dae1": {
    "message": "वर्ग अधिसमुच्चय"
  },
  "square_superset_strict_fa4262e4": {
    "message": "वर्ग अधिसमुच्चय (विशुद्ध)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "वर्ग अक्रमित सूची"
  },
  "star_8d156e09": {
    "message": "तारांकित करें"
  },
  "start_over_f7552aa9": {
    "message": "फिर से शुरू करें"
  },
  "start_recording_9a65141a": {
    "message": "रिकॉर्ड करना शुरू करें"
  },
  "steel_blue_14296f08": {
    "message": "स्टील ब्लू"
  },
  "studio_media_options_ee504361": {
    "message": "स्टूडियो मीडिया विकल्प"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "स्टूडियो मीडिया विकल्प ट्रे"
  },
  "styles_2aa721ef": {
    "message": "स्टाइल"
  },
  "submit_a3cc6859": {
    "message": "सबमिट करें"
  },
  "submitting_b90fac62": {
    "message": "सबमिट किया जा रहा है..."
  },
  "subscript_59744f96": {
    "message": "सबस्क्रिप्ट"
  },
  "subset_19c1a92f": {
    "message": "उपसमुच्चय"
  },
  "subset_strict_8d8948d6": {
    "message": "उपसमुच्चय (विशुद्ध)"
  },
  "succeeds_9cc31be9": {
    "message": "सफल हुआ"
  },
  "succeeds_equal_158e8c3a": {
    "message": "समान से सफल हुआ"
  },
  "sum_b0842d31": {
    "message": "योग"
  },
  "superscript_8cb349a2": {
    "message": "सुपरस्क्रिप्ट"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "सुपरस्क्रिप्ट और सबस्क्रिप्ट"
  },
  "superset_c4db8a7a": {
    "message": "अधिसमुच्चय"
  },
  "superset_strict_c77dd6d2": {
    "message": "अधिसमुच्चय (विशुद्ध)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "समर्थित फ़ाइल प्रकार: SRT या WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "सुंदर HTML संपादक पर स्विच करें"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "रॉ HTML संपादक पर स्विच करें"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "HTML संपादक पर स्विच करें"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "रिच टेक्स्ट संपादक पर स्विच करें"
  },
  "syllabus_f191f65b": {
    "message": "पाठ्यक्रम"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "सिस्टम ऑडियो की अनुमति है"
  },
  "system_audio_disabled_c177bd13": {
    "message": "सिस्टम ऑडियो अक्षम है"
  },
  "tab_arrows_4cf5abfc": {
    "message": "टैब/तीर"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "{ start } से शुरू होता तालिका हेडर"
  },
  "table_starting_with_start_e7232848": {
    "message": "{ start } से शुरू होती तालिका"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "तालिका हेडर में क्षेत्र निर्धारित किया जाना चाहिए।"
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "तालिकाओं में तालिका की सामग्री का वर्णन करने वाला एक कैप्शन शामिल होना चाहिए।"
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "तालिकाओं में कम से कम एक हेडर शामिल होना चाहिए।"
  },
  "tau_880974b7": {
    "message": "टाओ"
  },
  "teal_f729a294": {
    "message": "टील"
  },
  "text_7f4593da": {
    "message": "पाठ"
  },
  "text_background_color_16e61c3f": {
    "message": "पाठ पृष्ठभूमि रंग"
  },
  "text_color_acf75eb6": {
    "message": "पाठ रंग"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "पाठ और पृष्ठभूमि के बीच पर्याप्त कंट्रास्ट के बिना पाठ को पढ़ना मुश्किल है, खासकर कम दृष्टि वाले लोगों के लिए।"
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "18 पॉइंट (या बोल्ड 14 पॉइंट) से बड़े पाठ में न्यूनतम कंट्रास्ट अनुपात 3:1 प्रदर्शित होना चाहिए।"
  },
  "text_optional_384f94f7": {
    "message": "पाठ (वैकल्पिक)"
  },
  "text_position_8df8c162": {
    "message": "पाठ स्थिति"
  },
  "text_size_887c2f6": {
    "message": "पाठ साइज़"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "18 पॉइंट (या बोल्ड 14 पॉइंट) से छोटे पाठ में न्यूनतम कंट्रास्ट अनुपात 4.5:1 प्रदर्शित होना चाहिए।"
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "दस्तावेज़ पूर्वावलोकन वर्तमान में संसाधित किया जा रहा है। कृपया बाद में फिर से कोशिश करें।"
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "किसी पेज पर पहली हेडिंग H2 होनी चाहिए।"
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "रिच कॉन्टेंट एरिया की ऊंचाई घट गई है।"
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "रिच कॉन्टेंट एरिया की ऊंचाई बढ़ गई है।"
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "यह सामग्री सार्वजनिक डोमेन में है"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "इस सामग्री को Creative Commons के तहत लाइसेंस दिया गया है"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "सामग्री अपवाद के अधीन है - उदाहरण के लिए, उचित उपयोग, उद्धरण का अधिकार, या लागू कॉपीराइट कानूनों के तहत अन्य"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "सुंदर HTML संपादक में कुंजीपटल इस्तेमाल नहीं किया जा सकता। Shift O दबा कर रॉ HTML संपादक खोलें।"
  },
  "therefore_d860e024": {
    "message": "इसलिए"
  },
  "theta_ce2d2350": {
    "message": "थीटा"
  },
  "theta_variant_fff6da6f": {
    "message": "थीटा (प्रकार)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "मोटा अधोमुखी तीर"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "मोटा बायां तीर"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "मोटा बायां मुखी तीर"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "मोटा दायां तीर"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "मोटा दायां मुखी तीर"
  },
  "thick_upward_arrow_acd20328": {
    "message": "मोटा उर्ध्वगामी तीर"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "यह दस्तावेज़ Canvas के भीतर प्रदर्शित नहीं किया जा सकता।"
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "इस समीकरण को मूल दृश्य में प्रस्तुत नहीं किया जा सकता।"
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "यह छवि वर्तमान में अनुपलब्ध है"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "यह वीडियो Youtube विज्ञापन प्रदर्शित कर सकता है।"
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "हालांकि, आपके वीडियो का शीर्षक ब्राउज़र में सही तरीके से प्रदर्शित होगा, लेकिन हम उसे डेटाबेस में अपडेट करने में विफल रहे।"
  },
  "thumbnail_e0de666f": {
    "message": "थम्बनेल"
  },
  "timebar_a4d18443": {
    "message": "टाइमबार"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "शीर्षक खाली नहीं हो सकता"
  },
  "title_ee03d132": {
    "message": "शीर्षक"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "पोस्ट किया जाना है: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "करने के लिए: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "{ summary } ग्रुप टॉगल करें"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "टूलटिप टॉगल करें"
  },
  "tools_2fcf772e": {
    "message": "उपकरण"
  },
  "top_66e0adb6": {
    "message": "शीर्ष"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "ट्रांसक्रिप्ट पैनल 720px से अधिक की चौड़ाई पर उपलब्ध है।"
  },
  "tray_839df38a": {
    "message": "ट्रे"
  },
  "triangle_6072304e": {
    "message": "त्रिभुज"
  },
  "turnstile_yields_f9e76df1": {
    "message": "टर्नस्टाइल (प्रतिफल)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "छवि विकल्प एक्सेस करने के लिए कंट्रोल F9 टाइप करें। { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "लिंक विकल्प एक्सेस करने के लिए कंट्रोल F9 टाइप करें। { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "तालिका विकल्प एक्सेस करने के लिए कंट्रोल F9 टाइप करें। { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "संसाधन चयन URLनिर्धारित करने में असमर्थ"
  },
  "underline_applied_ae01ec97": {
    "message": "अंडरलाइन लागू किया गया"
  },
  "underline_removed_3693e17c": {
    "message": "अंडरलाइन निकाला गया"
  },
  "union_e6b57a53": {
    "message": "संघ"
  },
  "unpublished_dfd8801": {
    "message": "अप्रकाशित"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "बिना सहेजे गए बदलाव गायब हो जाएंगे।"
  },
  "untitled_16aa4f2b": {
    "message": "शीर्षकहीन"
  },
  "untitled_efdc2d7d": {
    "message": "शीर्षकहीन"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "ऊपर और बायां विकर्ण तीर"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "नीचे और दायां विकर्ण तीर"
  },
  "up_c553575d": {
    "message": "ऊपर"
  },
  "updated_link_a827e441": {
    "message": "अपडेट किया गया लिंक"
  },
  "upload_document_253f0478": {
    "message": "दस्तावेज़ अपलोड करें"
  },
  "upload_file_fd2361b8": {
    "message": "फ़ाइल अपलोड करें"
  },
  "upload_image_6120b609": {
    "message": "छवि अपलोड करें"
  },
  "upload_media_ce31135a": {
    "message": "मीडिया अपलोड करें"
  },
  "upload_record_media_e4207d72": {
    "message": "मीडिया अपलोड/रिकॉर्ड करें"
  },
  "uploading_19e8a4e7": {
    "message": "अपलोड किया जा रहा है"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "बड़े अक्षरों वाली क्रमित सूची"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "बड़े अक्षर वाला डेल्टा"
  },
  "uppercase_gamma_86f492e9": {
    "message": "बड़े अक्षर वाला गामा"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "बड़े अक्षर वाला लैम्ब्डा"
  },
  "uppercase_omega_8aedfa2": {
    "message": "बड़े अक्षर वाला ओमेगा"
  },
  "uppercase_phi_caa36724": {
    "message": "बड़े अक्षर वाला फ़ाई"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "बड़े अक्षर वाला पाई"
  },
  "uppercase_psi_6395acbe": {
    "message": "बड़े अक्षर वाला साई"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "बड़े अक्षर वाली रोमन अंकों की क्रमित सूची"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "बड़े अक्षर वाला सिग्मा"
  },
  "uppercase_theta_49afc891": {
    "message": "बड़े अक्षर वाला थीटा"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "बड़े अक्षर वाला अपसिलोन"
  },
  "uppercase_xi_341e8556": {
    "message": "बड़े अक्षर वाला शी"
  },
  "upsilon_33651634": {
    "message": "अपसिलोन"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "उर्ध्वगामी और अधोमुखी तीर"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "उर्ध्वगामी और अधोमुखी तीर (मोटा)"
  },
  "upward_arrow_9992cb2d": {
    "message": "उर्ध्वगामी तीर"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "उर्ध्वगामी त्रिभुज"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "उपयोग अधिकार:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "उपयोग अधिकार (आवश्यक)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "विकल्पों को नेविगेट करने के लिए तीर कुंजियों का उपयोग करें।"
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "आकार चुनने के लिए तीर कुंजियों का उपयोग करें।"
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "साइज़ चुनने के लिए तीर कुंजियों का उपयोग करें।"
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "पाठ स्थिति को चुनने के लिए तीर कुंजियों का उपयोग करें।"
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "पाठ साइज़ चुनने के लिए तीर कुंजियों का उपयोग करें।"
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "रूपरेखा साइज़ चुनने के लिए तीर कुंजियों का उपयोग करें।"
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "{ TYPE } की सामग्री का वर्णन करने के लिए स्क्रीन रीडर द्वारा उपयोग किया जाता है"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "छवि की सामग्री का वर्णन करने के लिए स्क्रीन रीडर द्वारा उपयोग किया जाता है"
  },
  "user_documents_c206e61f": {
    "message": "उपयोगकर्ता दस्तावेज़"
  },
  "user_files_78e21703": {
    "message": "उपयोगकर्ता फ़ाइलें"
  },
  "user_images_b6490852": {
    "message": "उपयोगकर्ता छवियां"
  },
  "user_media_14fbf656": {
    "message": "उपयोगकर्ता मीडिया"
  },
  "vector_notation_cf6086ab": {
    "message": "सदिश (नोटेशन)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "लंबवत पट्टी (सेट बिल्डर नोटेशन)"
  },
  "vertical_dots_bfb21f14": {
    "message": "लंबवत बिंदु"
  },
  "video_options_24ef6e5d": {
    "message": "वीडियो विकल्प"
  },
  "video_options_tray_3b9809a5": {
    "message": "वीडियो विकल्प ट्रे"
  },
  "video_player_b371005": {
    "message": "वीडियो प्लेयर"
  },
  "video_player_for_9e7d373b": {
    "message": "इसके लिए वीडियो प्लेयर: "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "{ title } के लिए वीडियो प्लेयर"
  },
  "video_url_889d3263": {
    "message": "वीडियो URL"
  },
  "view_all_e13bf0a6": {
    "message": "सभी देखें"
  },
  "view_ba339f93": {
    "message": "देखें"
  },
  "view_description_30446afc": {
    "message": "विवरण देखें"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "कुंजीपटल शॉर्टकट देखें"
  },
  "view_title_description_67940918": {
    "message": "{ title } विवरण देखें"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "शब्द और कैरेक्टर गिनती देखें"
  },
  "viewer_restrictions_e14274c9": {
    "message": "दर्शक प्रतिबंध"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "हम आपकी डिवाइस से कनेक्ट कार्यशील माइक्रोफ़ोन का पता नहीं लगा सके।"
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "हम आपकी डिवाइस से कनेक्ट कार्यशील वेबकैम का पता नहीं लगा सके।"
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "हम आपकी डिवाइस से कनेक्ट कार्यशील वेबकैम या माइक्रोफ़ोन का पता नहीं लगा सके।"
  },
  "webcam_disabled_30c66986": {
    "message": "वेबकैम अक्षम किया गया"
  },
  "webcam_fe91b20f": {
    "message": "वेबकैम"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "वेबपेजों में केवल एक H1 होना चाहिए, जो पेज के शीर्षक द्वारा स्वचालित रूप से उपयोग किया जाता है। आपकी सामग्री में पहली हेडिंग H2 होनी चाहिए।"
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "जब मार्कअप का उपयोग किया जाता है जो आइटमों को एक सूची के रूप में दृश्य रूप से प्रारूपित करता है, लेकिन सूची संबंध को इंगित नहीं करता है, तो उपयोगकर्ताओं को जानकारी नेविगेट करने में कठिनाई हो सकती है।"
  },
  "white_87fa64fd": {
    "message": "सफ़ेद"
  },
  "why_523b3d8c": {
    "message": "क्यों"
  },
  "width_492fec76": {
    "message": "चौड़ाई"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "चौड़ाई और ऊंचाई संखयाएं होनी चाहिए"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "विकी होम"
  },
  "word_count_c77fe3a6": {
    "message": "शब्दों की गिनती"
  },
  "words_b448b7d5": {
    "message": "शब्द"
  },
  "wreath_product_200b38ef": {
    "message": "पुष्पमाला उत्पाद"
  },
  "xi_149681d0": {
    "message": "शी"
  },
  "yes_dde87d5": {
    "message": "हां"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "आप कलर पैलेट पर हैं। पैलेट पर ऊपर, बाएं, नीचे या दाएं नेविगेट करने के लिए क्रमशः ''W'', ''A'', ''S'' और ''D'' बटन का उपयोग करें"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "आप कलर स्लाइडर पर हैं। स्लाइडर को बाएं या दाएं नेविगेट करने के लिए, क्रमशः ''A'' और ''D'' बटन का उपयोग करें"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "आप अल्फ़ा स्लाइडर पर हैं। स्लाइडर को बाएं या दाएं नेविगेट करने के लिए, क्रमशः ''A'' और ''D'' बटन का उपयोग करें"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "आपके पास Icon Maker ट्रे में असहेजे गए परिवर्तन हैं। क्या आप इन परिवर्तनों को सहेजे बिना जारी रखना चाहते हैं?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "पेज पदानुक्रम बनाए रखने के लिए आपको अतिरिक्त हेडिंग को एडजस्ट करने की आवश्यकता हो सकती है।"
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "आप खाली फ़ाइल अपलोड नहीं कर सकते।"
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "आपकी छवि Icon Maker के लिए संपीड़ित कर दी गई है। { size } KB से कम की छवियां संपीड़ित नहीं की जाएंगी।"
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "आपका माइक्रोफ़ोन ब्राउज़र सेटिंग्स में अवरोधित है।"
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "आपका वेबकैम और माइक्रोफ़ोन ब्राउज़र सेटिंग्स में अवरोधित हैं।"
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "आपका माइक्रोफ़ोन ब्राउज़र सेटिंग्स में अवरोधित है।"
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "हो सकता है कि आपका वेब कैम पहले से इस्तेमाल में हो।"
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube एम्बेड URL"
  },
  "zeta_5ef24f0e": {
    "message": "ज़ीटा"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "छवि ज़ूम इन करें"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "छवि ज़ूम आउट करें"
  }
};
formatMessage.addLocale({
  hi: locale
});